export const rooApiUrl = process.env.REACT_APP_GEOSERVER_URL
export const homeServerUrl = process.env.REACT_APP_HOME_SERVER_URL
export const workspaceName = process.env.REACT_APP_WORKSPACE_NAME